import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import type { BuilderAction } from '../builderReducer';
import type { BuilderState } from '../types';
import type { ChangeEvent, Dispatch } from 'react';

interface FormHeaderCardProps {
    dispatch: Dispatch<BuilderAction>;
    snapshot: BuilderState['snapshot'];
}

export function FormHeaderCard({ dispatch, snapshot }: FormHeaderCardProps) {
    return (
        <section className="overflow-hidden rounded-3xl border border-border bg-card shadow-elevation-1">
            <div className="h-2 bg-gradient-to-r from-brand to-info" />
            <div className="space-y-6 p-5 sm:p-7">
                <div className="space-y-1.5 border-b border-border/70 pb-5">
                    <h3 className="text-xl font-bold text-foreground">Informações do formulário</h3>
                </div>
                <div className="space-y-2">
                    <Label htmlFor="custom-survey-title">Título do formulário</Label>
                    <Input
                        id="custom-survey-title"
                        value={snapshot.name}
                        onChange={(event: ChangeEvent<HTMLInputElement>) =>
                            dispatch({
                                type: 'updateSurveyTitle',
                                value: event.target.value,
                            })
                        }
                        placeholder="Formulário sem título"
                    />
                </div>
                <div className="space-y-2">
                    <Label htmlFor="custom-survey-instructions">Instruções para o paciente</Label>
                    <Textarea
                        id="custom-survey-instructions"
                        value={snapshot.instructions ?? ''}
                        onChange={(event: ChangeEvent<HTMLTextAreaElement>) =>
                            dispatch({
                                type: 'updateSurveyInstructions',
                                value: event.target.value,
                            })
                        }
                        placeholder="Explique brevemente como o paciente deve responder."
                        className="min-h-24 resize-none"
                    />
                </div>
            </div>
        </section>
    );
}
